import React from 'react';
import { LANGS, LangCode } from '../../i18n/types';
import { useI18n } from '../../i18n/I18nContext';
import { trackEvent } from '../../analytics';

// Compact pill switcher: [RU][EN][PL]. Sits in the header.
export default function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const { lang, setLang } = useI18n();

  return (
    <div
      role="group"
      aria-label="Language"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        background: 'rgba(255,255,255,0.10)',
        border: '1px solid rgba(255,255,255,0.22)',
        borderRadius: 100,
        padding: 3,
        gap: 0,
        flexShrink: 0,
      }}
    >
      {LANGS.map((l) => {
        const active = l.code === lang;
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => { trackEvent('language_changed', { lang_from: lang, lang_to: l.code }); setLang(l.code as LangCode); }}
            aria-pressed={active}
            style={{
              padding: compact ? '4px 10px' : '5px 11px',
              borderRadius: 100,
              border: 'none',
              cursor: 'pointer',
              fontFamily: 'Manrope,sans-serif',
              fontSize: 11,
              fontWeight: 700,
              letterSpacing: '0.04em',
              background: active ? 'rgba(255,255,255,0.22)' : 'transparent',
              color: active ? 'white' : 'rgba(255,255,255,0.62)',
              transition: 'background 0.18s ease, color 0.18s ease',
            }}
            onMouseEnter={(e) => {
              if (!active) (e.currentTarget as HTMLButtonElement).style.color = 'rgba(255,255,255,0.92)';
            }}
            onMouseLeave={(e) => {
              if (!active) (e.currentTarget as HTMLButtonElement).style.color = 'rgba(255,255,255,0.62)';
            }}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  );
}
